/**
 * Generated by orval 🍺
 * Do not edit manually.
 * CliniShift Manager
 * The CliniShift Manager API is used to manage the CliniShift platform. This API is used by the CliniShift Manager Portal.
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const activityBaseOccurredAtRegExp = new RegExp('^\\d{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\\d|3[01])T(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\dZ$');


export const activityBaseChangesItemOneTwoFromRegExp = new RegExp('^\\d{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\\d|3[01])T(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\dZ$');
export const activityBaseChangesItemOneTwoToRegExp = new RegExp('^\\d{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\\d|3[01])T(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\dZ$');
export const activityBaseSnapshotItemOneTwoValueRegExp = new RegExp('^\\d{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\\d|3[01])T(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\dZ$');


export const ActivityBase = zod.object({
  "id": zod.string(),
  "type": zod.enum(['shift.updated', 'shift.published', 'shift.skills.changed', 'shift.assignment.assigned']),
  "occurred_at": zod.iso.datetime({"offset":true}).regex(activityBaseOccurredAtRegExp).describe('A timestamp in UTC \'ISO 8601\' format with a \'Z\' suffix. This format sometimes known as "Zulu" or "Zulu time".'),
  "actor": zod.union([zod.object({
  "type": zod.union([zod.enum(['employee', 'system']),zod.string()]),
  "display_name": zod.string()
}).and(zod.object({
  "type": zod.literal("employee"),
  "employee": zod.object({
  "id": zod.string().min(1).describe('A unique identifier for the resource.\n\n> This field is a string but the format of the value is not confirmed.\n>\n> *WIP*: The format of this field is not finalised or strictly defined.\n> This field may contain a simple ID in string format such as `"1"` or it may contain a UUID like `"a091dcb6-6e99-4e51-a8ee-69f67bcf2858"`'),
  "display_name": zod.string()
})
})).and(zod.object({
  "type": zod.enum(['employee'])
})),zod.object({
  "type": zod.union([zod.enum(['employee', 'system']),zod.string()]),
  "display_name": zod.string()
}).and(zod.object({
  "type": zod.literal("system")
})).and(zod.object({
  "type": zod.enum(['system'])
}))]),
  "subject": zod.object({
  "type": zod.enum(['shift']),
  "id": zod.string().min(1).describe('A unique identifier for the resource.\n\n> This field is a string but the format of the value is not confirmed.\n>\n> *WIP*: The format of this field is not finalised or strictly defined.\n> This field may contain a simple ID in string format such as `"1"` or it may contain a UUID like `"a091dcb6-6e99-4e51-a8ee-69f67bcf2858"`')
}),
  "summary": zod.object({
  "text": zod.string()
}),
  "changes": zod.array(zod.union([zod.object({
  "type": zod.union([zod.enum(['datetime', 'reference', 'reference_set']),zod.string()]),
  "field": zod.string(),
  "label": zod.string()
}).and(zod.object({
  "type": zod.literal("datetime"),
  "from": zod.iso.datetime({"offset":true}).regex(activityBaseChangesItemOneTwoFromRegExp).nullable().describe('A timestamp in UTC \'ISO 8601\' format with a \'Z\' suffix. This format sometimes known as "Zulu" or "Zulu time".'),
  "to": zod.iso.datetime({"offset":true}).regex(activityBaseChangesItemOneTwoToRegExp).nullable().describe('A timestamp in UTC \'ISO 8601\' format with a \'Z\' suffix. This format sometimes known as "Zulu" or "Zulu time".')
})).and(zod.object({
  "type": zod.enum(['datetime'])
})),zod.object({
  "type": zod.union([zod.enum(['datetime', 'reference', 'reference_set']),zod.string()]),
  "field": zod.string(),
  "label": zod.string()
}).and(zod.object({
  "type": zod.literal("reference"),
  "from": zod.union([zod.object({
  "type": zod.string(),
  "id": zod.string(),
  "display_name": zod.string()
}),zod.null()]),
  "to": zod.union([zod.object({
  "type": zod.string(),
  "id": zod.string(),
  "display_name": zod.string()
}),zod.null()])
})).and(zod.object({
  "type": zod.enum(['reference'])
})),zod.object({
  "type": zod.union([zod.enum(['datetime', 'reference', 'reference_set']),zod.string()]),
  "field": zod.string(),
  "label": zod.string()
}).and(zod.object({
  "type": zod.literal("reference_set"),
  "added": zod.array(zod.object({
  "type": zod.string(),
  "id": zod.string(),
  "display_name": zod.string()
})),
  "removed": zod.array(zod.object({
  "type": zod.string(),
  "id": zod.string(),
  "display_name": zod.string()
}))
})).and(zod.object({
  "type": zod.enum(['reference_set'])
}))])),
  "snapshot": zod.array(zod.union([zod.object({
  "type": zod.union([zod.enum(['datetime', 'reference', 'reference_set']),zod.string()]),
  "field": zod.string(),
  "label": zod.string()
}).and(zod.object({
  "type": zod.literal("datetime"),
  "value": zod.iso.datetime({"offset":true}).regex(activityBaseSnapshotItemOneTwoValueRegExp).describe('A timestamp in UTC \'ISO 8601\' format with a \'Z\' suffix. This format sometimes known as "Zulu" or "Zulu time".')
})),zod.object({
  "type": zod.union([zod.enum(['datetime', 'reference', 'reference_set']),zod.string()]),
  "field": zod.string(),
  "label": zod.string()
}).and(zod.object({
  "type": zod.literal("reference"),
  "value": zod.object({
  "type": zod.string(),
  "id": zod.string(),
  "display_name": zod.string()
})
}))]))
});

export type ActivityBase = zod.input<typeof ActivityBase>;
export type ActivityBaseOutput = zod.output<typeof ActivityBase>;
